import { render, staticRenderFns } from "./BaseAutocomplete.vue?vue&type=template&id=37e67822"
import script from "./BaseAutocomplete.vue?vue&type=script&lang=js"
export * from "./BaseAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./BaseAutocomplete.vue?vue&type=style&index=0&id=37e67822&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports